import { render, staticRenderFns } from "./provisao-filtrar.vue?vue&type=template&id=18098a13&scoped=true"
import script from "./provisao-filtrar.vue?vue&type=script&lang=js"
export * from "./provisao-filtrar.vue?vue&type=script&lang=js"
import style0 from "./provisao-filtrar.vue?vue&type=style&index=0&id=18098a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18098a13",
  null
  
)

export default component.exports